import React, { useContext } from 'react';
import { Context as ConfigContext } from '../Config';
import { useTranslation } from '../hooks/useTranslation';
import { usePageClassName } from '../hooksInternal/usePageClassName';
import WithTitle from '../componentsInternal/WithTitle';
const HomePage = ({}) => {
    const { t } = useTranslation();
    usePageClassName('index-page');
    const { pages } = useContext(ConfigContext);
    const title = t('pageTitles.home');
    const Page = pages.home.component;
    return (React.createElement(React.Fragment, null,
        React.createElement(WithTitle, { title: title },
            React.createElement(Page, null))));
};
HomePage.displayName = 'HomePage';
export default HomePage;
//# sourceMappingURL=home.js.map